import axios from 'axios';
import { downloadInvoiceReceipt } from '../utils/invoiceReceipt';

export async function getSavedInvoice(invoice) {
  if (!invoice?._id) throw new Error('A saved invoice ID is required.');
  let latest;
  if (invoice.invoiceNumber) {
    latest = (await axios.get(`/api/running/by-invoice/${encodeURIComponent(invoice.invoiceNumber)}`)).data;
  } else {
    const response = await axios.get('/api/running');
    if (!Array.isArray(response.data)) throw new Error('Unexpected invoice response.');
    latest = response.data.find(row => String(row._id) === String(invoice._id));
  }
  if (!latest || String(latest._id) !== String(invoice._id)) throw new Error('Saved invoice could not be confirmed. Refresh before downloading.');
  return latest;
}

export async function downloadLatestInvoiceReceipt(invoice) {
  const latest = await getSavedInvoice(invoice);
  downloadInvoiceReceipt(latest);
  return latest;
}
